import { createElement } from 'react';
import { ProFormUploadDragger as OriginalProFormUploadDragger } from '@ant-design/pro-components';
import moment from 'moment';
const ProFormUploadDragger = (props) => {
    const { obs, fieldProps, ...otherProps } = props;
    const { headers, action, method, ...othersFieldProps } = fieldProps;
    const { open: obsOpen = false, generateUrlFunction, } = obs;
    const handleGenerateAction = async (file) => {
        if (obsOpen && !generateUrlFunction) {
            throw new Error('缺少生成直传临时地址函数');
        }
        if (action) {
            return action;
        }
        const paths = ['upload', moment().format('YYYYMMDD').toString(), moment().valueOf(), file.name];
        const res = await generateUrlFunction({ ObjectKey: paths.join('/'), Headers: [] });
        return res.SignUrl;
    };
    return (createElement(OriginalProFormUploadDragger, { fieldProps: {
            action: handleGenerateAction,
            headers: {
                ...headers,
                ...(obs.open ? {
                    'Content-Type': 'text/plain'
                } : {})
            },
            method: obs.open ? 'PUT' : method,
            ...othersFieldProps,
        }, ...otherProps }));
};
export default ProFormUploadDragger;
